import React, { memo } from 'react';
import styled, { css } from 'styled-components';
import { HiOutlineQrcode } from 'react-icons/hi';
import { FiSearch } from 'react-icons/fi';
import { scanModeTabs } from '../config';
import type { ScanMode } from '../types/types';

type ScanModeTabsProps = {
	mode: ScanMode;
	onChange: (mode: ScanMode) => void;
};

// 스캔 모드 상단 탭 (QR 스캔 모드 / 직접 검색 모드)
const ScanModeTabs = memo<ScanModeTabsProps>(({ mode, onChange }) => {
	return (
		<Wrapper>
			{scanModeTabs.map((tab) => (
				<Tab key={tab.mode} $active={mode === tab.mode} onClick={() => onChange(tab.mode)}>
					{tab.mode === 'QR' ? <HiOutlineQrcode fontSize={20} /> : <FiSearch fontSize={18} />}
					{tab.label}
				</Tab>
			))}
		</Wrapper>
	);
});

ScanModeTabs.displayName = 'ScanModeTabs';

export default ScanModeTabs;

const Wrapper = styled.div`
	display: flex;
	border-radius: 6px;
	overflow: hidden;
	background-color: ${({ theme }) => theme.colors.lightGrayHoverColor};
`;
const Tab = styled.button<{ $active: boolean }>`
	flex: 1;
	height: 56px;
	font-size: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	cursor: pointer;
	color: ${({ theme }) => theme.colors.lightGrayFontColor};
	background-color: transparent;
	transition: 0.2s;

	${({ $active, theme }) =>
		$active &&
		css`
			font-family: PretendardSemiBold, AppleSDGothicNeoSemiBold, sans-serif;
			color: ${theme.colors.activeBlue};
			background-color: ${theme.colors.whiteColor};
			border-bottom: 2px solid ${theme.colors.activeBlue};
		`};
`;
